<template>
  <label :for="props.id" :class="{'required': required}">
    <slot></slot>
  </label>
</template>
<script setup>
const props = defineProps({
  id: {
    type: String,
    required: true
  },
  required: {
    type: Boolean,
  }
})
</script>
<style scoped>
label {
  display: inline-block;
  margin-block-end: .2rem;
}
.required::after {
  content: " *";
  color: var(--color-danger-500);
  font-size: 1.6rem;
  font-weight: 600;
  line-height: 0;
}
</style>